import { render, staticRenderFns } from "./role-select.vue?vue&type=template&id=13e86603"
import script from "./role-select.vue?vue&type=script&lang=js"
export * from "./role-select.vue?vue&type=script&lang=js"
import style0 from "./role-select.vue?vue&type=style&index=0&id=13e86603&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports